import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { categoryKeysWithPeriod } from "./calendarFilterCategories";

function CalendarCategoryFilterBar({
  activeFilters = [],
  onToggle,
  onToggleAll,
  onClear,
  categoryKeys,
  labelForKey,
  periodEnabled = false,
  hint,
}) {
  const { t } = useTranslation("athlete-portal");
  const visibleCategoryKeys = useMemo(
    () => categoryKeysWithPeriod(categoryKeys, periodEnabled),
    [categoryKeys, periodEnabled]
  );
  const allActive = activeFilters.length === visibleCategoryKeys.length;

  return (
    <div className="calendar-filter-bar">
      {/* Both spans are display:contents by default (calendar-log.css) —
          grouping hooks for Nutrition Log's own wrap layout (nutrition.css),
          invisible to the shared bar's default flat flex-wrap flow
          elsewhere. */}
      <span className="calendar-filter-controls">
        <span className="calendar-filter-label">
          {t("calendar.filter", "FILTER")}
        </span>
        <button
          type="button"
          className={`calendar-filter-all clipped border-gradient${allActive ? " active" : ""}`}
          onClick={onToggleAll}
        >
          {t("calendar.all", "All")}
        </button>
        <button type="button" className="calendar-filter-clear" onClick={onClear}>
          {t("calendar.clear", "Clear")}
        </button>
      </span>
      <span className="calendar-filter-pills">
        {visibleCategoryKeys.map((key) => (
          <button
            key={key}
            type="button"
            data-category={key}
            className={`calendar-filter-pill${activeFilters.includes(key) ? " active" : ""}`}
            onClick={() => onToggle(key)}
          >
            {labelForKey(key, t)}
          </button>
        ))}
        {/* Opt-in (undefined = nothing renders, so Plan/Calendar Log are
            unaffected) — last item in this SAME flex-wrap flow, so
            margin-left:auto (nutrition.css) pins it to the row's right edge
            on whichever line the pills end on, exactly like a pill would if
            it wrapped there. Only Nutrition's Log tab passes this, where
            .calendar-filter-pills is a real flex-wrap box (nutrition.css) —
            elsewhere (Plan/Calendar Log) that span is display:contents, so
            this would just flatten into the bar's own flow instead; still
            correct, just not currently used there.
            "chip info" (semantic.css) already gives the pill shape, the blue
            background/text and the info icon (::before) — same component
            used app-wide for this exact kind of hint, no need to rebuild it. */}
        {hint && <span className="chip info calendar-filter-hint">{hint}</span>}
      </span>
    </div>
  );
}

export default CalendarCategoryFilterBar;
